import { Link } from "react-router-dom";
import { PawPrint } from "@phosphor-icons/react";
import { BRAND_LOGO, BRAND_NAME } from "@/lib/brand";
import EditableSection from "@/components/blocks/EditableSection";
import AdminInlineEditButton from "@/components/AdminInlineEditButton";
import InstallButton from "@/components/InstallButton";

export default function PublicFooter() {
  return (
    <>
      <EditableSection slug="footer-extra" />
      <AdminInlineEditButton />
      <footer className="border-t border-stone-200 bg-white px-6 lg:px-12 py-14 text-stone-600">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <img src={BRAND_LOGO} alt={BRAND_NAME} className="h-14 w-auto mb-3" />
          <p className="text-sm leading-relaxed">Sunshine Coast Puppy Training with the Puppl team. Non-aversive, fear-free, evidence-based methods only.</p>
          <a href="mailto:support@puppl.app" className="text-sm text-[#f38838] hover:underline mt-3 inline-block">support@puppl.app</a>
        </div>
        <div>
          <div className="font-heading font-semibold text-stone-900 mb-3">Services</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-[#f38838]">All Services</Link></li>
            <li><Link to="/courses/in-person" className="hover:text-[#f38838]">In-Person Classes</Link></li>
            <li><Link to="/courses/online" className="hover:text-[#f38838]">Online Courses</Link></li>
            <li><Link to="/service-areas" className="hover:text-[#f38838]">Service Areas</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-semibold text-stone-900 mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#f38838]">About the team</Link></li>
            <li><Link to="/contact" className="hover:text-[#f38838]">Contact</Link></li>
            <li><Link to="/faq" className="hover:text-[#f38838]">FAQ</Link></li>
            <li><Link to="/testimonials" className="hover:text-[#f38838]">Testimonials</Link></li>
            <li><Link to="/tips" className="hover:text-[#f38838]">Training Tips</Link></li>
            <li><Link to="/general-tips" className="hover:text-[#f38838]">Puppy Owner's Guide</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-semibold text-stone-900 mb-3">Policies</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="hover:text-[#f38838]">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-[#f38838]">Privacy Policy</Link></li>
            <li><Link to="/non-aversive-policy" className="hover:text-[#f38838]">Non-Aversive Training</Link></li>
            <li><InstallButton /></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto pt-8 mt-10 border-t border-stone-200 text-sm flex flex-col sm:flex-row justify-between items-center gap-3">
        <div className="flex items-center gap-1.5 text-stone-500">
          <PawPrint size={14} weight="duotone" className="text-[#f38838]" />
          © {new Date().getFullYear()} Puppl. All Rights Reserved.
        </div>
        <div className="text-stone-500">Non-aversive, fear-free, evidence-based training only.</div>
      </div>
    </footer>
    </>
  );
}
